"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var theme_1 = require("../../utils/theme");
var context_1 = require("./context");
var Segment = (function (_super) {
    tslib_1.__extends(Segment, _super);
    function Segment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (e) {
            var _a, _b;
            (_b = (_a = _this.context).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, e, _this.props.id);
        };
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style = _b.style, children = _b.children, testId = _b.testId;
            var _c = _this.context, activeSegmentClassName = _c.activeSegmentClassName, activeSegmentRef = _c.activeSegmentRef, activeSegmentStyle = _c.activeSegmentStyle, segmentClassName = _c.segmentClassName, segmentStyle = _c.segmentStyle;
            var isActive = _this.isActive;
            var cls = classNames(prefixCls, segmentClassName, className, (_a = {},
                _a[activeSegmentClassName || ''] = isActive,
                _a[prefixCls + "-active"] = isActive,
                _a));
            return (h("div", { className: cls, style: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, segmentStyle), style), (isActive ? activeSegmentStyle : undefined)), onClick: _this.handleClick, "data-testid": testId, ref: isActive ? activeSegmentRef : undefined },
                _this.renderIcon(classNames),
                children));
        };
        return _this;
    }
    Object.defineProperty(Segment.prototype, "isActive", {
        get: function () {
            return this.context.activeId === this.props.id;
        },
        enumerable: false,
        configurable: true
    });
    Segment.prototype.renderIcon = function (classNames) {
        var _a = this.props, icon = _a.icon, activeIcon = _a.activeIcon, prefixCls = _a.prefixCls;
        var effectiveIcon = this.isActive ? (activeIcon || icon) : icon;
        var isIconUrl = typeof effectiveIcon === 'string';
        return effectiveIcon &&
            h("div", { className: classNames(prefixCls + "-icon-container") }, isIconUrl
                ? h("div", { className: classNames(prefixCls + "-icon"), style: { backgroundImage: "url(\"" + effectiveIcon + "\")" } })
                : effectiveIcon);
    };
    Segment.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    Segment.contextType = context_1.SegmentedControlContext;
    return Segment;
}(React.Component));
exports.default = Segment;
Segment.defaultProps = {
    prefixCls: 'dui-segmentedcontrol-segment'
};
